import { render } from "./ReviewCenter.vue?vue&type=template&id=5906f618&scoped=true"
import script from "./ReviewCenter.vue?vue&type=script&lang=js"
export * from "./ReviewCenter.vue?vue&type=script&lang=js"

import "./ReviewCenter.vue?vue&type=style&index=0&id=5906f618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906f618"]])

export default __exports__